import { colorsPalettes } from "@similarweb/styles";

import { translate } from "app/filters/i18nFilter";

const { carbon } = colorsPalettes;

export const DEFAULT_UN_CHECK_COLOR = carbon[200];
export const OTHER_COLOR = carbon[100];
export const getTotalKeywordsName = () => translate("common.total");
export const MAX_SELECTION = 5;
export const VISITS_DATA_THRESHOLD = 1000;
export const PERCENTAGE_SHARE_THRESHOLD = 0.05;

export const emptyStateSuggestedWebsites = [
    "hp.com",
    "hm.com",
    "asos.com",
    "lenovo.com",
    "eufy.com",
    "samsung.com",
    "dior.com",
    "uniqlo.com",
    "marksandspencer.com",
    "apple.com",
    "dell.com",
    "macys.com",
    "wayfair.com",
    "nike.com",
    "chanel.com",
    "next.co.uk",
    "nordstrom.com",
    "ikea.com",
    "anker.com",
    "zara.com",
];

export const compareModeEmptyStateWebsites = [
    "macys.com",
    "jcpenney.com",
    "bloomingdales.com",
    "nordstrom.com",
    "saksfifthavenue.com",
];
